import { BankRepository } from "./bankRepository";

/**
 * Serviço de consulta de bancos brasileiros.
 */
export class BankService {
  private bankRepository: BankRepository;
  constructor(bankRepository: BankRepository) {
    this.bankRepository = bankRepository;
  }

  /**
   * Retorna a lista completa de bancos.
   * @returns Lista de bancos
   */
  async list() {
    return await this.bankRepository.list();
  }

  /**
   * Busca bancos pelo nome completo (texto parcial).
   * @param query Texto parcial do nome do banco
   * @returns Lista de bancos correspondentes
   */
  async findByFullName(query: string) {
    return await this.bankRepository.findByFullName(query);
  }

  /**
   * Filtra bancos pelo código COMPE ou nome completo.
   * @param query Código numérico ou texto parcial do nome
   * @returns Lista de bancos correspondentes
   */
  async filterByCodeOrFullName(query: string) {
    return await this.bankRepository.filterByCodeOrFullName(query);
  }
}
